import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useMsal } from "@azure/msal-react";

import { ApolloProviderWithAuth } from "./ApolloProviderWithAuth";
import { AuthenticationLoading } from "./AuthenticationLoading";
import { DocumentIndexPage } from "./pages/Document";
import { ProtectedRoute } from "./ProtectedRoute";

export const Router: React.FC = () => {
  const { inProgress } = useMsal();
  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoute path="/portal" exact action="">
          <Redirect to="/portal/documents" />
        </ProtectedRoute>

        <ProtectedRoute path="/portal/documents" action="">
          <ApolloProviderWithAuth>
            <DocumentIndexPage />
          </ApolloProviderWithAuth>
        </ProtectedRoute>

        <Route path="/" exact>
          {((inProgress as string) !== "none" && <AuthenticationLoading />) || (
            <Redirect to="/portal" />
          )}
        </Route>

        <Route path="/callback" exact></Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
    </BrowserRouter>
  );
};
